/**
 * Захват экрана для desktop share (FullHD, до 15 fps capture).
 */
export async function captureDisplayMedia() {
  if (!navigator.mediaDevices?.getDisplayMedia) {
    throw new Error("Screen sharing is not supported in this browser.");
  }
  const stream = await navigator.mediaDevices.getDisplayMedia({
    video: {
      width: { ideal: 1920, max: 1920 },
      height: { ideal: 1080, max: 1080 },
      frameRate: { ideal: 15, max: 15 }
    },
    audio: false
  });
  const track = stream.getVideoTracks()[0];
  if (track) {
    try {
      track.contentHint = "detail";
    } catch {
      /* старые браузеры */
    }
  }
  return stream;
}
